'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';
import { signUpService } from '@/services/sign-up.service';
import webStorageKeys from '@/constants/web-storage-keys';

export const AffiliateBtagProvider = () => {
	const searchParams = useSearchParams();
	const hasRunRef = useRef(false);

	useEffect(() => {
		if (hasRunRef.current) return;
		hasRunRef.current = true;

		const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
		const btag = searchParams.get('btag');

		if (isAthena && btag) {
			sessionStorage.setItem(webStorageKeys.AFFILIATE_BTAG, btag);
			signUpService.displaySignUpModal(true);
		} else {
			sessionStorage.removeItem(webStorageKeys.AFFILIATE_BTAG);
		}
	}, []);

	return null;
};
